import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const showUnitSlice = createAsyncThunk("fetch/units", async function ({ id }, thunkApi) {
    try {
        const response = await api.get("/units/" + id);
        if (response.data.status == "success") {
            return { data: response.data.data };
        }
        return;
    } catch (error) {
        return thunkApi.rejectWithValue(error.response.data.message);
    }
});


export const showUnitSlicer = createSlice({
    name: "unit",
    initialState: {
        loading: false,
        error: null,
        unit: null,
        totalPages: 0,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(showUnitSlice.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(showUnitSlice.fulfilled, (state, action) => {
                state.loading = false;
                state.unit = action.payload.data;
            })
            .addCase(showUnitSlice.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});

export default showUnitSlicer.reducer;